import { ComponentPropsWithoutRef } from 'react'

import { cn } from '@sparkai/utils'

export type DotProps = ComponentPropsWithoutRef<'div'>

export function Dot({ className, ...props }: DotProps) {
  return (
    <div {...props} aria-hidden='true' className={cn('absolute h-[6px] w-[6px] rounded-full', className)} />
  )
}
